!(function () {
  "use strict";

  function findVideo(button) {
    var wrapper = button.closest("[data-video-controls]");
    return wrapper ? wrapper.querySelector("video") : null;
  }

  document.addEventListener("click", function (event) {
    var playButton = event.target.closest("[data-video-toggle-play]");
    if (playButton) {
      var video = findVideo(playButton);
      if (video) {
        if (video.paused) {
          video.play();
        } else {
          video.pause();
        }
      }
    }

    var muteButton = event.target.closest("[data-video-toggle-mute]");
    if (muteButton) {
      var muteVideo = findVideo(muteButton);
      if (muteVideo) {
        muteVideo.muted = !muteVideo.muted;
        var wrapper = muteButton.closest("[data-video-controls]");
        wrapper.classList.toggle("is-muted", muteVideo.muted);
        muteButton.setAttribute(
          "aria-label",
          muteVideo.muted ? theme.strings.unmuteVideo : theme.strings.muteVideo
        );
      }
    }
  });

  function setPlayState(event, isPlaying) {
    var wrapper = event.target.closest && event.target.closest("[data-video-controls]");
    if (!wrapper) return;
    wrapper.classList.toggle("is-playing", isPlaying);
    var playButton = wrapper.querySelector("[data-video-toggle-play]");
    if (playButton) {
      playButton.setAttribute("aria-label", isPlaying ? theme.strings.pauseVideo : theme.strings.playVideo);
    }
  }

  // play/pause events don't bubble, so listen with capture to catch them via delegation
  // (native controls, autoplay pausing off-screen, and our own button all fire these)
  document.addEventListener("play", function (event) { setPlayState(event, true); }, true);
  document.addEventListener("pause", function (event) { setPlayState(event, false); }, true);
})();
